'use client'

import { useRouter } from 'next/navigation'
import { clearAuthCredentials } from '@/utils/auth'

export default function LogoutButton() {
  const router = useRouter()

  const handleLogout = () => {
    clearAuthCredentials()
    // Call API to clear HttpOnly cookie, then navigate
    fetch('/api/auth/logout', { method: 'POST' }).finally(() => {
      router.push('/login')
    })
  }

  return (
    <button
      onClick={handleLogout}
      className="px-3 py-1 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
      title="Logout"
    >
      Logout
    </button>
  )
}
